// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__35bQM","title":"Info_title__luhb5","links":"Info_links__1_Qpr","link":"Info_link__3PR7C","logo":"Info_logo__2rctN"};